import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import HighestROI from "../../../images/icons/report-highest-roi.svg"
// import { convertCurrencyHelper } from '../../../helpers/forexConvertor';
import typeOfContract from '../../../constants/typeOfContract';
import { clientRioHigh } from '../ReportingOverview/Services/reportOverview.js';


// const calculateHighestRoiClient = (trackReport, reportingOverview, preferredCurrency, forex) => {

//   const clientData = {};
//   trackReport.forEach(entry => {
//     const { project, clientId, user, startTime, duration } = entry;
//     const year = reportingOverview.year || new Date().getFullYear();
//     const projectYear = new Date(startTime).getFullYear();
//     const projectId = project &&  project._id;

//     if (projectYear === year && project && !project.is_delete && reportingOverview.project.includes(projectId) && reportingOverview.currency.includes(clientId?.preferred_currency ||'USD')) {

//       const preferredClientCurrency = clientId?.preferred_currency || 'USD';
//       if (!clientData[clientId?._id]) {
//         clientData[clientId?._id] = {
//           budget: 0,
//           cost: 0,
//           details: clientId
//         };
//       }

//       clientData[clientId?._id].budget += convertCurrencyHelper(preferredClientCurrency, preferredCurrency, project.budget, forex);
//       const userCost = user.cost || 0;
//       const userOverheadCost = user.overhead_cost || 0;
//       const userTypeOfContract = user.typeOfContract || typeOfContract.Hourly_Rate;
//       const paymentCurrency = user.payment_currency || 'USD';

//       let finalCost;
//       if (userTypeOfContract === typeOfContract.Hourly_Rate) {
//         finalCost = userCost;
//       } else {
//         finalCost = userCost / 168; // Assuming a different type of contract with monthly rate divided by 168 hours
//       }

//       const cost = (finalCost * (duration / 3600)) + (userOverheadCost * (duration / 3600));
//       clientData[clientId?._id].cost += convertCurrencyHelper(paymentCurrency, preferredCurrency, cost, forex);
//     }
//   });
//   let highestROIClient = null;

//   for (const clientId in clientData) {
//     const client = clientData[clientId];
//     const roi = ((client.budget - client.cost) / client.cost) * 100;
//     client.roi = roi;
//     if (!highestROIClient || roi > highestROIClient.roi) {
//       highestROIClient = client;
//     }
//   }
//   return highestROIClient;
// };

// Functional component
function HighestRoi(props) {
  const [highestRoiClient, setHighestRoiClient] = useState(null);
  const [displayedRoi, setDisplayedRoi] = useState(0);
  const [targetRoi, setTargetRoi] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const animationFrameRef = useRef(null);

  const reportingOverview = useSelector((state) => state.reportingOverview);
  const { forex } = useSelector((state) => state.forex);
  const settings = JSON.parse(localStorage.getItem("settings"));
  const clientInvoices = props.clientInvoices;
  const trackReport = props.trackReport;
  const projectCost = props.projectCost;
  const expenses = props.expenses;

  const setReportingCurrency = useSelector((state) => state.reportingOverview.currency);
  var currencies = "USD";
  if (setReportingCurrency && setReportingCurrency.length === 1) {
    currencies = setReportingCurrency[0];
  } else {
    currencies = settings.currency;
  }

  useEffect(() => {
    // const highestClient = calculateHighestRoiClient(props.trackReport, reportingOverview, settings.currency, forex);
    const highestClient = clientRioHigh(trackReport, projectCost, clientInvoices, reportingOverview, currencies, forex, typeOfContract, expenses);

    setHighestRoiClient(highestClient);
    if (highestClient && highestClient.roi !== undefined) {
      setTargetRoi(parseFloat(highestClient.roi.toFixed(2)));
    } else {
      setTargetRoi(0);
    }
  }, [reportingOverview, forex, currencies, trackReport, projectCost, expenses, clientInvoices]);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    // Cancel any existing animation
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
    }

    const startValue = displayedRoi;
    const endValue = targetRoi;
    const duration = 1000; // Animation duration in milliseconds
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Easing function for smooth animation (ease-out)
      const easeOut = 1 - Math.pow(1 - progress, 3);
      
      const currentValue = startValue + (endValue - startValue) * easeOut;
      setDisplayedRoi(parseFloat(currentValue.toFixed(2)));

      if (progress < 1) {
        animationFrameRef.current = requestAnimationFrame(animate);
      } else {
        setDisplayedRoi(endValue);
        animationFrameRef.current = null;
      }
    };

    if (Math.abs(startValue - endValue) > 0.01) {
      animationFrameRef.current = requestAnimationFrame(animate);
    }

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [targetRoi]);

  return (
    <div style={{ 
      opacity: isVisible ? 1 : 0,
      transition: 'opacity 0.5s ease-in'
    }}>
      <div className="overview-item">
        <div className="overview-title-outer">
          <div className="overview-title">
            Highest ROI
            <div className='client-name-report'>{highestRoiClient ? highestRoiClient.details.client_name : 'N/A'}</div>
          </div>
          <div className="overview-icon">
            <img src={HighestROI} alt="cLock" />
          </div>
        </div>

        <div className="overview-rice">
          {highestRoiClient ? `${displayedRoi.toFixed(2)}%` : 'N/A'}
        </div>
      </div>
    </div>

  );
}

export default HighestRoi;